import { DanceManagerUserGroupsInterface } from '../interfaces';

export class EditUserGroupRequestDto implements DanceManagerUserGroupsInterface {
  name: string;
  userIds: string[];
}
